import getWindow from "../../utils/window";

export const getCommonRecommendedOutfitsTrackingValues = (product) => {
  const s = getWindow().s;

  return {
    pageName: `style: ${product?.id}`,
    prop4: `${s.prop1}~${s.prop2}~${s.prop3}`,
    prop8: "styled for you",
    eVar60: "styled for you",
    eVar61: "styled for you",
  };
};
